export enum BookingStaleTimeEnum {
  GetBooking = 60000,
  GetUserBookings = 60000,
  SearchBookings = 1000,
  GetRemainingBookingsCheck = 60000,
}
